<div class="row"
  style="width:100%; float: right; text-align: right; margin-top: 0px; padding-top: 0px; margin-right:0px !important">
  <div class="col-11"></div>
  <div class="col-1 text-right" style="float:right; margin-right:0px; padding-right:0px;">
    <mat-icon style="float:right; cursor: pointer;" (click)="onNoClick()">cancel</mat-icon>
  </div>
</div>
<h1 mat-dialog-title>{{labels.lblAddTraining}}</h1>
<div mat-dialog-content>
  <section class="example-section">
    <ul>
      @for (training of trainings; track training) {
        <li class="list">
          <mat-checkbox [checked]="isChecked(training._id)" (change)="addTraining($event.checked, training._id)" class="example-margin">{{training.name}}</mat-checkbox>
        </li>
      }
    </ul>
    <button class="btn btn-info" (click)="onSubmit()">{{labels.lblSave}}</button>
  </section>
</div>
